import { ApiProspectType, ProspectType } from "@/types";

export function normalizeProspect(prospect: ApiProspectType): ProspectType {
  return {
    id: prospect.id,
    uuid: prospect.uuid,
    firstName: prospect.first_name,
    lastName: prospect.last_name,
    phoneNumber: prospect.phone_number,
    email: prospect.email,
    streetAddress1: prospect.street_address_1,
    streetAddress2: prospect.street_address_2,
    city: prospect.city,
    state: prospect.state,
    status: prospect.status,
    zipCode: prospect.zip_code,
    desiredMoveInDate: prospect.desired_move_in_date,
    desiredNumberOfBedrooms: prospect.desired_number_of_bedrooms,
    realtorInfo: prospect.realtor_info,
    isRealEstateAgent: prospect.is_real_estate_agent,
    waitListOptedInAt: prospect.wait_list_opted_in_at,
    allowSmsNotifications: prospect.allow_sms_notifications,
  };
}
